import React from "react";
import "./App.css";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { inject, observer } from "mobx-react";
import { NonIdealState, Spinner } from "@blueprintjs/core";
import Landing from "./micro/generic/Landing";
import { apiCallPost } from "./micro/fns/util";
import { withAuth0 } from "@auth0/auth0-react";
import cogoToast from "cogo-toast";
import SearchDisplayHOC from "./micro/generic/SearchDisplayHOC";
import SxLanding from "./micro/sx/SxLanding";
import PaymentReceiptPage from "./micro/sx/PaymentReceiptPage";
import ImplantBillPage from "./micro/sx/ImplantBillPage";
import FinalInvoicePage from "./micro/sx/FinalInvoicePage";
import DischargeTemplatesCRUD from "./micro/v2/DischargeTemplatesCRUD";
import AppLayout from "./v3/layouts/AppLayout";
import Dashboard from "./v3/pages/Dashboard";
import V3App from "./v3/V3App";
import SurgerySearch from "./v3/pages/workflow/SurgerySearch";
import { ThemeProvider } from "./contexts/ThemeContext";
import { getHospitalName } from "./v3/utils/hospitalName";

class App extends React.Component {
  state = {
    authing: false,
    hydrated: false,
  };
  componentDidMount = async () => {
    this.pollID = this.poll();
  };
  poll = () => {
    var a = setInterval(() => {
      let isHydrated = this.props.root.getHydration();

      if (isHydrated) {
        this.setState({ hydrated: true });
        this.getJWT();
      } else {
      }
    }, 1000);
    return a;
  };
  clearPoll = async () => {
    clearInterval(this.pollID);
    try {
      this.setState({ authing: true });
      // Only make API call if we have a valid token
      const token = localStorage.getItem("auth0jwt");
      if (token) {
        const me = await apiCallPost("/auth/me");
        const root =
          me && typeof me === "object" && me.data != null && typeof me.data === "object" && !("prefix" in me)
            ? me.data
            : me;
        const {
          prefix,
          scope,
          name,
          id,
          email,
          userEmail,
          username,
        } = root || {};
        const nestedUserEmail = root?.user?.email;
        const resolvedEmail =
          email ||
          userEmail ||
          username ||
          nestedUserEmail ||
          (typeof name === "string" && name.includes("@") ? name : "") ||
          "";
        this.props.authStore.prefix = prefix;
        this.props.authStore.isLoggedIn = true;
        this.props.authStore.scope = scope;
        this.props.authStore.name = name;
        this.props.authStore.id = id;
        this.props.authStore.email = (resolvedEmail || "").trim() || null;
        this.props.authStore.hospitalName =
          root?.hospitalName ||
          root?.orgName ||
          root?.organization?.name ||
          getHospitalName(prefix);
      } else if (this.props.auth0.isAuthenticated && this.props.auth0.user) {
        // If no token but user is authenticated, set basic user info from Auth0
        this.props.authStore.prefix = "default";
        this.props.authStore.isLoggedIn = true;
        this.props.authStore.scope = "user";
        this.props.authStore.name = this.props.auth0.user.name || this.props.auth0.user.email || "User";
        this.props.authStore.id = this.props.auth0.user.sub || "unknown";
        this.props.authStore.email = (this.props.auth0.user.email || "").trim() || null;
      }
      this.setState({ authing: false });
    } catch (err) {
      console.error("Auth error:", err);
      this.setState({ authing: false });
      localStorage.setItem("authStore", null);
      localStorage.setItem("auth0jwt", null);
      // Only show error and logout if user was authenticated
      if (this.props.auth0.isAuthenticated) {
        cogoToast.error("Unauthorized User");
        this.props.auth0.logout({ returnTo: window.location.origin });
      }
    }
  };
  getJWT = async () => {
    // Only try to get token if user is authenticated
    if (!this.props.auth0.isAuthenticated) {
      console.log("User not authenticated, skipping token request");
      this.clearPoll();
      return;
    }

    try {
      let x = await this.props.auth0.getAccessTokenSilently({
        audience: "https://newchart.us.auth0.com/api/v2/",
        scope: "read:current_user openid profile email",
      });
      localStorage.setItem("auth0jwt", x);
      this.clearPoll();
      return;
    } catch (error) {
      console.error("Error getting access token:", error);
      // If we can't get a token, still proceed with basic auth
      this.clearPoll();
    }
  };
  render() {
    // Debug logging
    console.log("App render - Auth0 state:", {
      isAuthenticated: this.props.auth0?.isAuthenticated,
      isLoading: this.props.auth0?.isLoading,
      user: this.props.auth0?.user,
      error: this.props.auth0?.error
    });
    console.log("App render - Auth store state:", {
      isLoggedIn: this.props.authStore?.isLoggedIn,
      name: this.props.authStore?.name
    });

    if (!this.state.hydrated) {
      return (
        <ThemeProvider>
          <div className="App">
            <div className="main">
              <NonIdealState
                className="bp3-dark"
                icon={<Spinner />}
                title="Loading..."
                description="We're ensuring your data is consistent..."
              />
            </div>
          </div>
        </ThemeProvider>
      );
    }
    if (this.state.authing) {
      return (
        <ThemeProvider>
          <div className="App">
            <div className="main">
              <NonIdealState
                className="bp3-dark"
                icon={<Spinner />}
                title="Loading..."
                description="We're verifying authentication status..."
              />
            </div>
          </div>
        </ThemeProvider>
      );
    }
    
    // Check if Auth0 is properly loaded
    if (!this.props.auth0) {
      return (
        <ThemeProvider>
          <div className="App bp3-dark">
            <div className="main">
              <NonIdealState
                className="bp3-dark"
                icon="error"
                title="Authentication Error"
                description="Auth0 is not properly configured. Please refresh the page."
              />
            </div>
          </div>
        </ThemeProvider>
      );
    }
    
    if (!this.props.auth0.isAuthenticated) {
      return (
        <ThemeProvider>
          <div className="App bp3-dark">
            <BrowserRouter>
              <Route path="/" component={Landing} />
            </BrowserRouter>
          </div>
        </ThemeProvider>
      );
    }
    if (!this.props.authStore.isLoggedIn) {
      return (
        <ThemeProvider>
          <div className="App bp3-dark">
            <BrowserRouter>
              <Route path="/" component={Landing} />
            </BrowserRouter>
          </div>
        </ThemeProvider>
      );
    }

    return (
      <ThemeProvider>
        <div className="App bp3-dark">
          <div className="main v3-main">
            <BrowserRouter>
              <Switch>
                <Route path="/v3" component={V3App} />
                <Route path="/">
                  <AppLayout>
                    <Route path="/" exact component={Dashboard} />
                  <Route path="/sxCounsellingPrompt" exact>
                    <SearchDisplayHOC
                      displayTitle="Counselling Prompt"
                      entityType="sxCounsellingPrompt"
                      icon="chat"
                      indexContentName="Prompt"
                      renderType="LIST"
                    />
                  </Route>
                  <Route path="/sxConsentList" exact>
                    <SearchDisplayHOC
                      displayTitle="Consent List"
                      entityType="sxConsentList"
                      icon="form"
                      indexContentName="Consent"
                      renderType="LIST"
                    />
                  </Route>
                  <Route path="/sxOTMaster" exact>
                    <SearchDisplayHOC
                      displayTitle="Operating Theatre"
                      entityType="sxOTMaster"
                      icon="cut"
                      indexContentName="OT"
                      renderType="LIST"
                    />
                  </Route>
                  <Route path="/sxDischargeTemplateMaster" exact>
                    <DischargeTemplatesCRUD />
                  </Route>
                  <Route path="/sxPaymentPanelMaster" exact>
                    <SearchDisplayHOC
                      displayTitle="Payment Panel"
                      entityType="sxPaymentPanelMaster"
                      icon="credit-card"
                      indexContentName="Checklist"
                      renderType="LIST"
                    />
                  </Route>
                  <Route path="/sxTPAMaster" exact>
                    <SearchDisplayHOC
                      displayTitle="TPA"
                      entityType="sxTPAMaster"
                      icon="inner-join"
                      indexContentName="Checklist"
                      renderType="LIST"
                    />
                  </Route>
                  <Route path="/sxAnaesthesiaPriceMaster" exact>
                    <SearchDisplayHOC
                      displayTitle="Anaesthesia Price"
                      entityType="sxAnaesthesiaPriceMaster"
                      icon="syringe"
                      renderType="TABLE"
                      columns={["Type", "Site", "Hospital Charge", "Anaesthetist Fee", "Total"]}
                    />
                  </Route>
                  <Route path="/sxBedMaster" exact>
                    <SearchDisplayHOC
                      displayTitle="Bed and Ward"
                      entityType="sxBedMaster"
                      icon="home"
                      renderType="TABLE"
                      columns={["Site", "Bed", "Ward", "Rate"]}
                    />
                  </Route>
                  <Route path="/sxPriceMaster" exact>
                    <SearchDisplayHOC
                      displayTitle="Surgery Price"
                      entityType="sxPriceMaster"
                      icon="bank-account"
                      // renderType="TABLE"
                      // columns={[
                      //   "Name",
                      //   "Sites",
                      //   "Panel Name",
                      //   "Panel Rate",
                      //   "Panel L1 Cap",
                      //   "Panel Delta",
                      //   "Panel Repetition",
                      // ]}
                    />
                  </Route>
                  <Route path="/sxSurgeonSchedule" exact>
                    <SearchDisplayHOC
                      displayTitle="Surgeon Schedule"
                      entityType="sxSurgeonSchedule"
                      icon="timeline-events"
                      renderType="TABLE"
                      columns={["Schedule"]}
                    />
                  </Route>
                  <Route path="/sxAnaesthetistSchedule" exact>
                    <SearchDisplayHOC
                      displayTitle="Anaesthetist Schedule"
                      entityType="sxAnaesthetistSchedule"
                      icon="timeline-events"
                      renderType="TABLE"
                      columns={[
                        "Anaesthetist",
                        "Site",
                        "From",
                        "To",
                        "Mon",
                        "Tues",
                        "Wed",
                        "Thurs",
                        "Fri",
                        "Sat",
                        "Sun",
                      ]}
                    />
                  </Route>
                  <Route path="/sx" exact>
                    <SearchDisplayHOC
                      displayTitle="Surgical Procedure"
                      entityType="sxBooking"
                      icon="cut"
                      renderType="TABLE"
                      columns={[
                        "Surgery ID",
                        "Patient ID",
                        "Patient Name",
                        "Patient Age",
                        "Patient Gender",
                        "Surgeries",
                        "Eye",
                        "Items needed in Surgery",
                        "Anaesthesia",
                        "Remarks",
                        "Diet",
                        "Site",
                        "Surgeon",
                        "Date",
                        "Lifecycle",
                        "Details",
                      ]}
                    />
                  </Route>
                  <Route path="/SxPostSurgeryContactList" exact>
                    <SearchDisplayHOC
                      displayTitle="Post Surgery Contact"
                      entityType="SxPostSurgeryContactList"
                      icon="person"
                      renderType="TABLE"
                      columns={["Name", "Phone", "Availability"]}
                    />
                  </Route>
                  <Route path="/SxAdverseEventMaster" exact>
                    <SearchDisplayHOC
                      displayTitle="Adverse Event"
                      entityType="SxAdverseEventMaster"
                      icon="issue"
                      renderType="TABLE"
                      columns={["Adverse Event", "Description"]}
                    />
                  </Route>

                  <Route path="/sxBookingReport" exact>
                    <SearchDisplayHOC
                      displayTitle="Surgery Report"
                      entityType="sxBookingReport"
                      icon="cut"
                      renderType="GRID"
                    />
                  </Route>

                  <Route path="/sxPaymentReport" exact>
                    <SearchDisplayHOC
                      displayTitle="Payment Report"
                      entityType="sxPaymentReport"
                      icon="credit-card"
                      renderType="GRID"
                    />
                  </Route>

                  <Route path="/sxInsuranceReport" exact>
                    <SearchDisplayHOC
                      displayTitle="Insurance Report"
                      entityType="sxInsuranceReport"
                      icon="bank-account"
                      renderType="GRID"
                    />
                  </Route>

                  <Route path="/sxItemConsumptionReport" exact>
                    <SearchDisplayHOC
                      displayTitle="Item Consumption Report"
                      entityType="sxItemConsumptionReport"
                      icon="full-stacked-chart"
                      renderType="GRID"
                    />
                  </Route>

                  <Route path="/sxBookingRegisterReport" exact>
                    <SearchDisplayHOC
                      displayTitle="Surgery Register Report"
                      entityType="sxBookingRegisterReport"
                      icon="cut"
                      renderType="GRID"
                    />
                  </Route>

                  <Route path="/sx/:sxId" exact>
                    <SxLanding />
                  </Route>

                  <Route path="/SurgerySearch" exact component={SurgerySearch} />

                  <Route path="/neo/sx/i/:sxId" exact>
                    <PaymentReceiptPage />
                  </Route>

                  <Route path="/neo/sx/implant/:sxId" exact>
                    <ImplantBillPage />
                  </Route>

                  <Route path="/neo/sx/invoice/:sxId" exact>
                    <FinalInvoicePage />
                  </Route>
                  </AppLayout>
                </Route>
              </Switch>
            </BrowserRouter>
          </div>
        </div>
      </ThemeProvider>
    );
  }
}

export default inject("root", "authStore")(observer(withAuth0(App)));
